export interface MetricRisk {
  values: any[];
  children: any[];
}

/**
 * Safely select a single risk metric from a handleReportRisks() map.
 * When the backend response omits the requested metric the map has no entry,
 * so this returns a fresh empty result instead of throwing on undefined.values.
 * A fresh literal is returned on each miss so empty results are never aliased
 * across grid blocks.
 */
export const selectMetricRisk = (risks: Record<string, any>, metric: string): MetricRisk =>
  risks?.[metric] ?? { values: [], children: [] };
